<template>
  <div  >
<!--    <loading-block v-if="!is_load" :loading="!is_load"/>-->
  <nav v-if="is_load"   class="navbar    bg-light">
    <a class="col-md-2 col-lg-2 navbar-brand" v-if="is_load && !(url_logotype && url_logotype.length>0)" href="/">{{ title_site}}</a>
    <a class="col-md-2 col-lg-2 navbar-brand" v-if="is_load && (url_logotype && url_logotype.length>0)" href="/"><img :src="url_logotype"></a>


    <div class="row col-md-10 col-lg-10  " id="navbarSupportedContent">
      <div class="col-md-7   col-12   mainnavbar meganav_base_double">
      <ul class="navbar-nav mr-auto uppernavbar">

        <li v-bind:class="{ active: typebar=='link_'+main_link.id, notactive:typebar!='link_'+main_link.id }" :title="main_link.alt" class="nav-item" v-if="main_links.length>0" v-for="(main_link,main_link_key) in main_links" :key="main_link_key" >
          <a class="nav-link" @click="changeSubbar('link_'+main_link.id,main_link_key)" v-html="main_link.title">


          </a>
        </li>


      </ul>
      </div>
      <div class="d-flex justify-content-start justify-content-md-end form-inline my-2  my-lg-0  col-md-5 col-12">
        <a title="Сменить оформление" class="my-2 my-sm-0  btn btn-outline-success " @click="changeTheme" ><i class="ni ni-air-baloon"></i></a>

        <router-link  :to="{name: 'shop_cart'}" class="btn   btn-outline-success my-2 my-sm-0"  tag="a"><i class="ni ni-cart"></i><span v-if="cart.length>0" class="badge">{{ cart.length}}</span></router-link>


        <router-link class="btn btn-second btn-outline-success my-2 my-sm-0"  v-if="islogin==false"  :to="{name: 'login',query: { nextUrl: $route.fullPath }}"  tag="button">Войти</router-link>
        <router-link v-if="islogin==true" :to="{name: 'setup_link'}" class="btn btn-second  mt-lg-0 mt-xl-0  my-2 my-sm-0"  > Настройки <badge v-if="total_count>0"
            type="danger">{{
            total_count
          }}</badge></router-link>
      </div>
    </div>
  </nav>
    <div class="alert" v-if="is_load && islogin==true && $route.query && $route.query.after_login=='show' && is_show_after_login==true">
      <h2>Вы успешно авторизовались!</h2>
      <button class="btn" @click="closeAfterLogin">Закрыть</button>
    </div>
    <div class=" mt-3 ml-4"  v-if="is_load && main_links.length>0 && main_link.links && main_link.links.length>0 && typebar=='link_'+main_link.id" v-for="(main_link,main_link_key) in main_links" :key="'div_'+main_link_key">
      <h2>{{ main_link.title}}</h2>
      <div class="subnav_block">
        <router-link :data-id="sub_link.id" :title="sub_link.alt" :class="{active:(subbar_active_type==sub_link.type),not_active:!(subbar_active_type==sub_link.type)}" tag="a" :to="sub_link.type" v-for="(sub_link,sub_link_key) in main_link.links" :key="'sublink_'+sub_link.id"   >
          {{sub_link.title}}
          <b v-if="sub_link.type=='/leadtasks'"><badge v-if="notify_count_tasks>0"
              type="danger">{{
              notify_count_tasks
            }}</badge></b>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import BaseNotifyDropdown from "@/components/BaseNotifyDropdown";
import CloseButton from "@/components/CloseButton";
import {vueTelegramLogin} from 'vue-telegram-login'
import axios from 'axios';
import {eventBus} from '../main.js';
import Vue from "vue";
import Api from "../models/Api";
import {vm} from "../main.js";
import Modal from "@/components/Modal";
import LoginModal from "../components/LoginModal";
import Avatar from 'vue-avatar'
import UserModel from "../models/UserModel";
import LogoComponent from "@/components/Custom/LogoComponent";
import LoadingBlock from "../components/Custom/LoadingBlock";


require('dotenv').config()

export default {

  components: {
    LoadingBlock,
    Modal,
    BaseNav,
    CloseButton,
    BaseDropdown,
    BaseNotifyDropdown,
    vueTelegramLogin,
    LoginModal,
    Avatar,
    "LogoComponent":LogoComponent,

  },

  data: function () {

    return {
      'is_show_after_login':true,
      'typebar':'',
      'url_logotype':null,
      'subbar_active_link':'',
      'subbar_active_type':'',
      'cart':[],
      'total_count':0,
      'pages_categorys':[],
      'categorys_blog':{},
      loaded_blog_category:false,
      "telegram_bot": null,
      is_disable_editor:false,
      user: {},
      test_user:{},
      is_load_pages: false,
      pages: [],
      random_code: '',
      funnels:[],
      'main_links':[],
      "current_theme":"day_mode",
      is_notify_load: false,
      new_task_developer: null,
      "loaded_categorys": false,
      "categorys": null,
      "notifys": null,
      "notify": {
        "show_only_unread": true,
      },
      'modal_params': {},
      "modals": {
        "add_project": null,
      },
      "notify_counts": {
        "projects": 0,
        "freelance": 0,
        "comments": 0,
        "invoices": 0,
      },
      "modal_add_title": "Размещение проекта",
      "is_show_category": true,
      "is_add_task": false,
      "iserror": false,
      "error_message": null,
      "modal_btn_add_project": "Отправить на оценку",
      "form": {
        'category': null,
        'json': {},
        'fields':{},
      },
      "config": {},
      notify_count: 0,
      notify_count_invoices:0,
      notify_count_tasks:0,
      islogin: false,
      'istgbot': false,
      'timer': '',
      'timer_check_code': '',
      show_modal_after_login: true,
      'slogans':[],
      "total_cart_price":0,
      'is_load':false,
      'title_site':'',
      'current_meta':{

      },
    }
  },
  metaInfo () {
    var app=this;
    var result={
      meta:[],
    };
    if(app.current_meta && app.current_meta.title && app.current_meta.title.length>0) {
      result.title=app.current_meta.title;

    }
    if(app.current_meta && app.current_meta.description && app.current_meta.description.length>0){
      result.meta.push( { vmid: 'description', name: 'description', content: app.current_meta.description });
    }

    if(app.current_meta && app.current_meta.image && app.current_meta.image.url>0){
      result.meta.push( { vmid: 'og:image', name: 'og:image', content: app.current_meta.image.url });
    }



    return result;
  },
  mounted: function () {




    this.url_logotype=Vue.config.URL_LOGOTYPE;


    if(this.$route.meta.typebar){
      this.typebar=this.$route.meta.typebar;
    }else {
      this.typebar='';
    }


    var current_url=new URL(this.$route.fullPath, window.location.origin).href;


    //alert(this.$route.fullPath);

    Api.loadAboutGetConfWithUrl(current_url,function(data){
      app.title_site='Сайт';
      app.current_meta=data.current_meta;
      app.main_links=data.links;
      if(app.main_links.length>0){
        app.main_links.forEach(function(elem,index){
          if(elem.type==app.$route.path){
            app.typebar="link_"+elem.id;
          }
          if(elem.type=="/services" && app.$route.path.includes("/service/")){
            app.typebar="link_"+elem.id;
          }
          if(elem.type=="/works" && app.$route.path.includes("/works")){
            app.typebar="link_"+elem.id;
          }
          if(elem.links && elem.links.length>0){

            elem.links.forEach(function(subelem,index){


              if(subelem.type==app.$route.path){
                app.typebar="link_"+elem.id;
                app.subbar_active_link=subelem.id;
                app.subbar_active_type=subelem.type;
              }else if(subelem.type=="/services" && app.$route.path.includes("/service/")){
                app.typebar="link_"+elem.id;
                app.subbar_active_link=subelem.id;
                app.subbar_active_type=subelem.type;
              }else if(subelem.type=="/works" && app.$route.path.includes("/works")){
                app.typebar="link_"+elem.id;
                app.subbar_active_link=subelem.id;
                app.subbar_active_type=subelem.type;
              }
            });

          }
        });
      }

      if(data.about && data.about.title){
        app.slogans=data.about.slogans;
        app.title_site=data.about.title;

        // document.title=data.about.title;
      }

      app.pages_categorys=data.pages_categorys;
      app.is_load=true;
    });
    if(this.$route.query && this.$route.query.nextUrl && this.$route.query.nextUrl.length>0){

      //this.addProject(false);
    }




    this.random_code = Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10);
    var app=this;
    app.cart=Api.getCart();


    Api.syncCart();



    eventBus.$on("theme_is_changed",data=>{
      var theme=data.theme;

      app.current_theme=theme;

    });
    eventBus.$on("sync_cart",cart=>{
      app.cart=cart;
      app.total_cart_price=cart.length;
    });
    eventBus.$on("telegram_login",data=>{
      app.addProject(false);
    });



    Api.loadPages(function (data) {

      app.pages = data;
      if (app.pages.length > 0) {
        app.is_load_pages = true;
      }

    });
    Api.loadCategorys(function (data) {
      app.categorys = data;
      app.loaded_categorys = true;
    });




    var tmpUser = UserModel.get();



    if(tmpUser && tmpUser.api_token) {

      //app.updateNotifyCount();
      //  app.timer = setInterval(app.updateNotifyCount, 20000);


      if(this.$route.query && this.$route.query.nextUrl && this.$route.query.nextUrl.length>3){
        //app.$router.push(app.$route.query.nextUrl);
        //var rand_string=Math.ceil(Math.random()*10);
        document.location.href=this.$route.query.nextUrl;
      }

      this.islogin = true;
      this.user = tmpUser;
      app.updateNotifyCount();
      // app.timer = setInterval(app.updateNotifyCount, 2000);

      if (app.islogin == true && app.user.islead == 1) {
        Api.loadFunnels(function (datas) {
          if (datas.funnels.length > 0) {
            app.funnels = datas.funnels;
          }
        })
      }
    }





    // let tg_widget = document.createElement('script');
    // tg_widget.setAttribute("src", "https://telegram.org/js/telegram-widget.js?14");
    // tg_widget.setAttribute("data-telegram-login", "Noibizcombot");
    // tg_widget.setAttribute("data-size", "small");
    // tg_widget.setAttribute("data-request-access", "write");
    // //tg_widget.setAttribute("data-onauth", "this.telegramLoginCallback(user)");
    // tg_widget.setAttribute("data-auth-url", "http://1aaa54bb86e2.ngrok.io/#/onlogin");
    // tg_widget.setAttribute("async", "");
    //
    // this.$refs.telegram_login.appendChild(tg_widget);
  },
  methods: {
    setIsLoad(){
      this.$emit('set_is_load',true);
    },
    changeSubLink(sublink_path){
      var app=this;
      if(app.main_links.length>0){

        app.main_links.forEach(function(elem,index){
          if(elem.type==sublink_path){
            app.typebar="link_"+elem.id;
          }
          if(elem.type=="/services" && sublink_path.includes("/service/")){
            app.typebar="link_"+elem.id;
          }
          if(elem.type=="/works" && sublink_path.includes("/works")){
            app.typebar="link_"+elem.id;
          }
          if(elem.links && elem.links.length>0){

            elem.links.forEach(function(subelem,index){


              if(subelem.type==sublink_path){
                app.typebar="link_"+elem.id;
                app.subbar_active_link=subelem.id;
                app.subbar_active_type=subelem.type;
              }else if(subelem.type=="/services" && sublink_path.includes("/service/")){
                app.typebar="link_"+elem.id;
                app.subbar_active_link=subelem.id;
                app.subbar_active_type=subelem.type;
              }else if(subelem.type=="/works" && sublink_path.includes("/works")){
                app.typebar="link_"+elem.id;
                app.subbar_active_link=subelem.id;
                app.subbar_active_type=subelem.type;
              }
            });

          }
        });

      }
    },
    closeAfterLogin(){
      var app=this;
      app.is_show_after_login=false;
      return false;
    },
    changeTheme() {
      eventBus.$emit("changeTheme");

    },
    changeSubbar(typebar,index) {
      var current_link=this.main_links[index];
      if(current_link.links && current_link.links.length>0){
        this.typebar=typebar;
      }else {
        this.typebar=typebar;
        this.$router.push(current_link.type);
      }

    },
    updateNotifyCount() {

      var app = this;


      try{
        Api.loadNotifyCount(function (notifys) {


          app.notify_count = notifys.count;
          app.notify_count_invoices=notifys.count_invoices;
          app.notify_count_tasks=notifys.count_tasks;
          var total_count=app.notify_count+app.notify_count_invoices;
          app.total_count=total_count;

          var emit_params={};
          emit_params.notify_count=app.notify_count;
          emit_params.notify_count_invoices=app.notify_count_invoices;
          emit_params.notify_count_tasks=app.notify_count_tasks;
          eventBus.$emit("update_notify_count",emit_params)


        });
      } catch(e){

      }

      setTimeout(app.updateNotifyCount, 5000)


    },
  }
};
</script>
<style>
</style>
